module.exports = __webpack_public_path__ + "static/media/CreditMemoUI2.59299b20.png";